export default __webpack_public_path__ + "static/media/navbar-logo.2f9824a0.png";